import { Card } from '@ipfabric/ui-components/Card/Card';
import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import type { IconGlyph } from '@ipfabric/ui-components/Icon/IconGlyph';
import { getLoadPercentageColorClass } from 'pages/Support/Status/helpers/getLoadPercentageColorClass';
import type { FC } from 'react';

type Props = {
  title: string;
  glyph: IconGlyph;
  overall: number | null;
  isPercent?: boolean;
  thresholdPercent?: number | null;
  details: [label: string, value: string][];
};

const getOverallColorClass = (props: Props): string => {
  if (props.overall === null || props.overall === undefined) {
    return 'text-status-error';
  }
  const percent = props.isPercent
    ? props.overall
    : (props.thresholdPercent ?? null);
  return percent === null ? '' : getLoadPercentageColorClass(percent);
};

export const HardwareLoadCard: FC<Props> = (props) => (
  <Card className='flex flex-row flex-1 gap p'>
    <Icon
      iconStyle='duotone'
      glyph={props.glyph}
      size='xl'
      className='text-element-secondary'
    />
    <div className='flex-1'>
      <div className='flex flex-row gap justify-between text-base font-semibold'>
        <span>{props.title}</span>
        <span className={getOverallColorClass(props)}>
          {props.overall?.toFixed(2) ?? '?'}
          {props.isPercent && ' %'}
        </span>
      </div>
      {props.details.map(([label, value], index) => (
        <div
          key={`${index}/${label}`}
          className='flex flex-row justify-between text-xs text-plain'
        >
          <span>{label}</span>
          <span>{value}</span>
        </div>
      ))}
    </div>
  </Card>
);
